import React, { createContext, useContext, useState } from 'react';

interface FloatingChatState {
  isActive: boolean;
  chatId: string | null;
  isCollapsed: boolean;
  chatData: any;
}

interface FloatingChatContextType {
  floatingChat: FloatingChatState;
  activateFloatingChat: (chatId: string, chatData: any) => void;
  deactivateFloatingChat: () => void;
  toggleCollapsed: () => void;
}

const FloatingChatContext = createContext<FloatingChatContextType | undefined>(undefined);

export const FloatingChatProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [floatingChat, setFloatingChat] = useState<FloatingChatState>({
    isActive: false,
    chatId: null,
    isCollapsed: false,
    chatData: null
  });

  const activateFloatingChat = (chatId: string, chatData: any) => {
    setFloatingChat({
      isActive: true,
      chatId,
      isCollapsed: false,
      chatData
    });
  };

  const deactivateFloatingChat = () => {
    setFloatingChat({
      isActive: false,
      chatId: null,
      isCollapsed: false,
      chatData: null
    });
  };

  const toggleCollapsed = () => {
    setFloatingChat(prev => ({
      ...prev,
      isCollapsed: !prev.isCollapsed
    }));
  };

  return (
    <FloatingChatContext.Provider 
      value={{
        floatingChat,
        activateFloatingChat,
        deactivateFloatingChat,
        toggleCollapsed
      }}
    >
      {children}
    </FloatingChatContext.Provider>
  );
};

export const useFloatingChat = () => {
  const context = useContext(FloatingChatContext);
  if (context === undefined) {
    throw new Error('useFloatingChat must be used within a FloatingChatProvider');
  }
  return context;
};
